import queryString from 'query-string';
import { pathOr } from 'ramda';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import searchService from 'services/searchService';

import { search, searchPage, types } from './actions';
import { PAGE_SIZE, TAB_TYPES } from './constants';
import {
  getActiveTab,
  getFilters,
  getPageNumber,
  getSearchQuery,
} from './reducer';

export default function* root() {
  yield takeLatest(types.ACTIVE_TAB_SET, watchSearch);
  yield takeLatest(types.PAGINATE, watchSearch);
  yield takeLatest(types.SEARCH_PAGE_INIT, watchInit);
  yield takeLatest(types.SEARCH_REQUEST, watchSearch);
}

const sortDirectionToPrefixMap = {
  ascending: '',
  descending: '-',
};

function* performSearch(
  pageNumber,
  paginateFrom,
  tab,
  filters,
  query,
  onSuccess,
) {
  try {
    window.history.replaceState(
      {},
      '',
      `/contacts?${queryString.stringify({
        tab,
        page: pageNumber,
        search: query ?? '',
      })}`,
    );

    let orderBy = [];
    if (filters) {
      orderBy = Object.keys(filters)
        .filter((key) => filters[key].sortState.direction)
        .sort(
          (a, b) =>
            filters[a].sortState.priority - filters[b].sortState.priority,
        )
        .map(
          (key) =>
            sortDirectionToPrefixMap[filters[key].sortState.direction] +
            key.split(',')[1],
        );
    }

    const [accountsResponse, contactsResponse] = yield all([
      call(searchService.accounts, {
        query,
        paginateFrom: tab == TAB_TYPES.ACCOUNTS ? paginateFrom : 0,
        ordering: orderBy,
      }),
      call(searchService.contacts, {
        query,
        paginateFrom: tab == TAB_TYPES.CONTACTS ? paginateFrom : 0,
        ordering: orderBy,
      }),
    ]);

    yield put(
      onSuccess({
        accounts: accountsResponse.results,
        accountsCount: accountsResponse.count,
        contacts: contactsResponse.results,
        contactsCount: contactsResponse.count,
        query: query,
      }),
    );
  } catch (error) {
    yield put(search.error(error));
  }
}

function* watchInit() {
  const pageNumber = 1;
  const paginateFrom = 0;
  const tab = yield select(getActiveTab);
  const filters = [];
  const query = '';

  yield performSearch(
    pageNumber,
    paginateFrom,
    tab,
    filters,
    query,
    searchPage.success,
  );
}

function* watchSearch() {
  const pageNumber = yield select(getPageNumber);
  const paginateFrom = (pageNumber - 1) * PAGE_SIZE;
  const query = yield select(getSearchQuery);
  const tab = yield select(getActiveTab);
  const filters = yield select(getFilters);

  yield performSearch(
    pageNumber,
    paginateFrom,
    tab,
    filters,
    query,
    search.success,
  );
}

export function* initSearchPage({ location }) {
  try {
    const queryParams = queryString.parse(location.search);
    yield put(
      searchPage.init({
        page: Number(pathOr(1, ['page'], queryParams)),
        tab: pathOr(TAB_TYPES.ACCOUNTS, ['tab'], queryParams),
        query: pathOr('', ['search'], queryParams),
      }),
    );
  } catch (error) {
    console.error('Error in initSearchPage saga', error);
  }
}
